export default __webpack_public_path__ + "static/media/WebCoursesScreen.dfcee033.gif";